import request from '@/utils/request'

export const getHunters = () =>
  request({
    url: '/statistics/roles.show?role=Hunter&page=1&per_page=100',
    method: 'get'
  })

export const createHunter = (data: any) =>
  request({
    url: '/hunters.store',
    method: 'post',
    data
  })

export const updateHunter = (data: any) =>
  request({
    url: '/hunters.update',
    method: 'post',
    data
  })

export const assignHunter = (data: any) =>
  request({
    url: '/hunters.assign',
    method: 'post',
    data
  })

export const deleteHunter = (id: number) =>
  request({
    url: '/hunters.delete?hunter_id=' + id,
    method: 'delete'
  })
